// extracted by mini-css-extract-plugin
export default {"root":"SocialMediaIcons_root__XZy6v","divider":"SocialMediaIcons_divider__8Tv99"};